import Joi from '@hapi/joi'

export const exportTagDetailsSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please select valid Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Company").messages({
        "any.invalid": `Please select valid Company`,
        "any.required": `Company required`
    }),
    tagNumber: Joi.string().invalid("").label("Tag Number").required().messages({
        "any.invalid": `Please Enter Tag Number`,
        "any.required": `Tag Number required`
    }),
}